import React, { Component } from 'react';
import ActionEditorContainer from '../ActionEditorContainer';
import ActionApiEditorComponent from './ActionApiEditorComponent';

class ActionApiEditorContainer extends Component {
  public render() {
    return <ActionEditorContainer editor={<ActionApiEditorComponent />} type='api' icon='api' />;
  }
}

export default ActionApiEditorContainer;
